import React, {memo, useReducer, useState, useCallback, useEffect} from 'react';
import { connect } from "react-redux";
import {getStepFromXPosition} from './position.js';
import {
    setAutomationGuidePoint,
    setAutomationPointsSelected,
    setAutomationPointHasMoved,
    setAutomationPointDragging} from 'actions/index.js';
import {uuid} from 'uuidv4';
import {addAutomationBreakpoint} from 'operations/actions.js';
import {reducer, init} from './reducer.js';
import { Text, Tag, Label, Circle, Group, Stage, Layer, Rect, Line} from 'react-konva';
import {
    getXPositionFromStep,
    getYPositionFromValue
} from './position.js';
import AutomationTooltip from './AutomationTooltip.js';

const tooltipFill ='#4f4d54';

const GuidePoint = memo(({
    setPointDragging,
    setPointHasMoved,
    setPointsSelected,
    track,
    guidePoint,
    selectedParameter,
    xScale,
    dispatch,
    pointDragging,
    height,
    width,
    isMix,
    wrapperRef,
    clearGuidePoint}) => {
        const onClickLine = useCallback(async (e) => {
            e.stopPropagation();
            let operationManager = track.sequencerEngine.operationManager;
            let x = isMix ? e.clientX - 140 + wrapperRef.current.scrollLeft :
                e.clientX - 56 + wrapperRef.current.scrollLeft;
            let step = getStepFromXPosition(x, xScale, width);
            let value = isMix ?
                selectedParameter.mixAutomation.getValueAtStep(step) : 
                selectedParameter.automation.getValueAtStep(step);
            let ret =
                await operationManager.dispatch(
                    addAutomationBreakpoint(
                        isMix ? selectedParameter.mixAutomation : selectedParameter.automation,
                        step,
                        value,
                        uuid()
                    ));
            let point = ret && ret.point;
            dispatch({type:'setSelectedPoint', payload: point});
            clearGuidePoint();
            setPointHasMoved(true);
            setPointsSelected([]);
            setPointDragging(point);
        }, [
            width,
            clearGuidePoint,
            selectedParameter,
            xScale,
            dispatch]);

        if (guidePoint === undefined ||
            selectedParameter === undefined ||
            pointDragging !== undefined) {
            return (
                <Layer>
                  <Rect x={0} y={0} width={0} height={0}></Rect>
                </Layer>
            );
        }

        let x = getXPositionFromStep(guidePoint.step, xScale, width);
        let y = getYPositionFromValue(
            guidePoint.value,
            height,
            selectedParameter.min,
            selectedParameter.max);

        return (
            <ellipse
              onMouseDown={onClickLine}
              cx={x}
              cy={y}
              rx={4}
              ry={4}
              fill={'#5802d9'}
              stroke={'#5802d9'}
              strokeWidth={2} />
        );
    });

const mapStateToProps = (state, props) => {
    return {
        guidePoint: state.automation.guidePoint[props.track.id]
    };
};

const mapDispatchToProps = (dispatch, props) => {
    return {
        clearGuidePoint: () => dispatch(setAutomationGuidePoint(props.track.id, undefined)),
        setPointDragging: (point) => dispatch(setAutomationPointDragging(props.track.id, point)),
        setPointsSelected: (points) => dispatch(setAutomationPointsSelected(props.track.id, points)),
        setPointHasMoved: (hasMoved) => dispatch(setAutomationPointHasMoved(props.track.id, hasMoved))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(GuidePoint);



